/**
 * Typografia PL — twarde spacje (PLAN-IMPLEMENTACJI §8.4, wymóg twardy).
 *
 * Cienki adapter na `@no-human/typografia` (lista wspólnych słów, reguły
 * `units` i `legal`): sieroty z listy, „art. 5”, „§ 3”, „ust. 2”, „8 000 zł”,
 * „15 %”. Funkcja jest idempotentna — raz wstawione U+00A0 nie jest ruszane.
 */
import { NBSP, hardSpaces } from '@no-human/typografia'

export { NBSP }

/** Wstawia twarde spacje w polskim tekście (reguły `units` i `legal`). */
export function nbsp(text: string): string {
  return hardSpaces(text, { rules: { units: true, legal: true } })
}
